export default [
    {
      name: "BrandonGrotesque",
      type: "font",
      path: "./fonts/BrandonGrotesque.json",
    },
]; 